<template>
    <v-card class="expense-card" style="background-color:">
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
            {{ callbackResponse.message }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="sticky-toolbar">
            <v-toolbar class="toolbar" color="indigo" dark>
                <v-toolbar-title>
                    {{$t('view')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialogueClose" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </div>
  
        <v-container>
            <v-timeline :dense="$vuetify.breakpoint.smAndDown" v-for="(report, index) in expensesReport" :key="report.officeBudgetExpenseID">
                <v-timeline-item v-if="index % 2 === 0"
                                 :color="index % 2 === 0 ? 'purple lighten-2' : 'blue lighten-2'"
                                 style="padding-bottom:0px;padding-top:0px"
                                 right>
                    <v-card class="custom-design">
                        <v-card-title class="custom-title" :style="getSubjectRowStyle(index)">
                            <span>  {{index+1}}</span>
                            <v-icon dark
                                    size="42"
                                    class="mr-4">
                                mdi-calendar-text
                            </v-icon>
                            <h2 class="text-h6 white--text font-weight-bold">
                                {{report.monthName}}  [ {{report.subsectionName}} ]
                            </h2>
                        </v-card-title>
                        <v-container :style="{ backgroundColor: report.colorCode }">

                            <v-row class="font-weight-bold">
                                <v-col cols="12">
                                    <v-icon size="22">mdi-pencil</v-icon>
                                    {{ report.remarks }}
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6" md="6" class="text--success">
                                    <v-icon size="22" color="success">mdi-currency-rupee</v-icon>
                                    ({{ report.amount }})
                                </v-col>

                                <v-col cols="6" md="6" class="text--warning">
                                    <v-icon size="22" color="warning">mdi-list-status</v-icon>
                                    {{ report.workStatusName }}
                                </v-col>
                            </v-row>


                        </v-container>
                    </v-card>
                </v-timeline-item>
                <v-timeline-item v-else
                                 :color="index % 2 === 0 ? 'purple lighten-2' : 'blue lighten-2'"
                                 style="padding-bottom:0px;padding-top:0px"
                                 left
                                 small>
                    <v-card class="custom-design">
                        <v-card-title class="custom-title" :style="getSubjectRowStyle(index)">
                            <span style="color:white">  {{index+1}}</span>
                            <v-icon dark
                                    size="42"
                                    class="mr-4">
                                mdi-calendar-month
                            </v-icon>
                            <h2 class="text-h6 white--text font-weight-bold">
                                {{report.monthName}} [ {{report.subsectionName}} ]
                            </h2>
                        </v-card-title>
                        <v-container :style="{ backgroundColor: report.colorCode }">

                            <v-row class="font-weight-bold">
                                <v-col cols="12">
                                    <v-icon size="22">mdi-pencil</v-icon>
                                    {{ report.remarks }}
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6" md="6" class="text--success">
                                    <v-icon size="22" color="success">mdi-currency-rupee</v-icon>
                                    ({{ report.amount }})
                                </v-col>

                                <v-col cols="6" md="6" class="text--warning">
                                    <v-icon size="22" color="warning">mdi-list-status</v-icon>
                                    {{ report.workStatusName }}
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-timeline-item>
            </v-timeline>

        </v-container>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'ViewComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                    errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
        },
        props: ['viewData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                expenses: {
                    monthID: "4",
                    amount: 0,
                    remarks: "",
                    workingStatus: "1",
                    companyID: 0,
                    branchID: 0,
                    depoID: 0,
                },
                table: false,
                dialogCreate: false,
                snackbar: false,
                monthList: [],
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                expensesReport: [],
                helpData: [],
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                logData: this.$route.query,
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                workStatusList: [],
                color: ""
            };
        },
        validations: {
            logData: {
                companyID: { required },
                year: { required },
            }
        },
        mounted() {
            this.loadData();
        },

        methods: {
            dialogueClose() {
                this.$emit("formResponse", this.servicesData);
            },
            loadData() {
                let param = {
                    reportID: parseInt(this.viewData.reportID),
                    fiscalYearID: parseInt(this.viewData.yearID),
                    companyID: 0,
                    branchID: null,
                    depoID: null,

                }
                axios.post("ReportSettings/GetOfficeExpensesReportDataAsync", param).then(response => {
                    this.expensesReport = response.data
                }).catch(response => {
                    this.expensesReport = response.data
                });
            },
            getSubjectRowStyle(subjectIndex) {
                const colors = ['#ba68c8', '#ffca28', '#26c6da', '#ef5350', '#66bb6a']; // Define the desired color codes
                const backgroundColor = colors[subjectIndex % colors.length];
                return `background-color: ${backgroundColor}; margin:auto`;
            },

        }
    };
</script>

<style scoped>
    .expense-card {
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .toolbar {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .actions {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: #e0e0e0;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .custom-save-button {
        color: white;
        background-color: #1976d2;
    }

    .custom-radio .v-input--selection-controls__input {
        display: none; /* Hide the default radio button */
    }

    .custom-radio .v-icon {
        font-size: 24px; /* Adjust the icon size */
        color: #ccc; /* Default icon color */
        transition: color 0.3s;
    }

    /* Apply different colors based on index */
    .custom-radio:nth-child(1) .v-icon {
        color: #FF5733;
    }

    .custom-radio:nth-child(2) .v-icon {
        color: #3A89F1;
    }

    .custom-radio:nth-child(3) .v-icon {
        color: #9C27B0;
    }

    .custom-textarea .v-input__control {
        border-color: #bdbdbd;
    }

    .custom-textarea .v-label {
        color: #757575;
        font-weight: 500;
        font-size: 14px;
    }

    .custom-textarea .v-input__icon--clear {
        color: #bdbdbd;
    }

    .custom-textarea textarea {
        font-size: 14px;
        color: #333;
        border: none;
        resize: vertical;
    }

        .custom-textarea textarea:focus {
            box-shadow: 0 0 0 2px #1976d2;
        }

        /**/

    .custom-design {
        transition: transform 0.2s, box-shadow 0.2s; /* Add box-shadow to the transition */
        cursor: pointer;
        box-shadow: 0 0 0 transparent; /* Start with no shadow */
    }

        .custom-design:hover {
            transform: scale(1.02);
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* Add a shadow on hover */
        }

        .custom-design h3,
        .custom-design p {
            font-size: 12px;
            margin: 5px 0;
        }
    .custom-title {
        padding:5px;
    }

</style>
